$ = require 'jquery'
ReactDOM = require '@trello/react-dom-wrapper'
React = require 'react'

{ BillableGuestsAlert } = require 'app/common/components/billable-guests-alert'
BillableGuestListPopoverView = require 'app/scripts/views/board/billable-guest-list-popover-view'
PopOver = require 'app/scripts/views/lib/pop-over'
View = require 'app/scripts/views/internal/view'
template = require 'app/scripts/views/templates/popover_reopen_board'
OrgFeatures = require('@trello/product-features').OrganizationFeatures
isDesktop = require('@trello/browser').isDesktop()

module.exports = class ReopenBoardPopoverView extends View
  viewTitleKey: 'reopen board'

  events:
    'click .js-confirm-reopen': 'confirmReopen'

  initialize: ({ @board, @org, @newBillableGuests, @availableLicenseCount, @onReopen }) ->
    super

  remove: ->
    if @reactRoot
      ReactDOM.unmountComponentAtNode(@reactRoot)
    super

  renderReactSection: ->
    productCode = @org.get('paidAccount')?.products?[0]

    props =
      adminNames: @org.adminList.map((member) -> member.get('fullName') || member.get('username'))
      newBillableGuestsCount: @newBillableGuests.length
      availableLicenseCount: @availableLicenseCount
      orgName: @org.get('displayName') || @org.get('name')
      pricePerGuest: OrgFeatures.getPrice(productCode)
      isMonthly: OrgFeatures.isMonthly(productCode)
      isOrgAdmin: @org.owned()
      isDesktop: isDesktop
      orgUrl: @org.url
      isReopen: true
      onCountClick: => PopOver.pushView {
        view: new BillableGuestListPopoverView({ @newBillableGuests })
      }

    Element = React.createElement BillableGuestsAlert, props
    if @reactRoot = @$('.js-billable-guests-alert')[0]
      ReactDOM.render(Element, @reactRoot)

  render: ->
    @$el.html(template())
    @renderReactSection()
    @

  confirmReopen: (e) ->
    keepBillableGuests = @org.owned() && !isDesktop
    if @org.owned() && @availableLicenseCount != null && @availableLicenseCount < @newBillableGuests.length
      keepBillableGuests = false
    @board.reopen({ @newBillableGuests, keepBillableGuests })
    @onReopen?()
    PopOver.hide()
